import { Box, Typography } from '@mui/material';
import AvatarImage from '../../common/avatar-image';

interface MemberNameColProps {
  id?: string;
  providerId?: string;
  displayName?: string;
}

const cellTypoStyle = {
  fontFamily: 'Be Vietnam Pro',
  fontSize: '16px',
  fontWeight: '400',
  lineHeight: '24px',
  letterSpacing: '0.5px',
  textAlign: 'left'
};

const MemberNameCol = ({
  id,
  providerId,
  displayName
}: MemberNameColProps): JSX.Element => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <AvatarImage
        key={id}
        providerId={providerId as string}
        alt={displayName}
        fontSize={'15px'}
      />
      <Typography sx={cellTypoStyle}>{displayName}</Typography>
    </Box>
  );
};
export default MemberNameCol;
